var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStats(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2651",
    "data-name": "Group 2651",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.946,
    height: 21.292,
    viewBox: "0 0 18.946 21.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3789",
    "data-name": "Path 3789",
    d: "M56.4,68.352V61.79a1.373,1.373,0,0,1,1.39-1.39h3.042a1.373,1.373,0,0,1,1.39,1.39v6.561a1.373,1.373,0,0,1-1.39,1.39H57.791A1.373,1.373,0,0,1,56.4,68.352Zm4.693-.478V62.268a.686.686,0,0,0-.7-.7H58.268a.686.686,0,0,0-.7.7v5.605a.686.686,0,0,0,.7.7H60.4A.685.685,0,0,0,61.093,67.874Z",
    transform: "translate(-43.277 -48.494)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3790",
    "data-name": "Path 3790",
    d: "M41.3,62.345V51.09a1.373,1.373,0,0,1,1.39-1.39h3.042a1.373,1.373,0,0,1,1.39,1.39V62.345a1.373,1.373,0,0,1-1.39,1.39H42.69A1.373,1.373,0,0,1,41.3,62.345Zm4.693-.478v-10.3a.686.686,0,0,0-.7-.7H43.168a.686.686,0,0,0-.7.7v10.3a.686.686,0,0,0,.7.7H45.3A.715.715,0,0,0,45.993,61.867Z",
    transform: "translate(-34.739 -42.443)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3791",
    "data-name": "Path 3791",
    d: "M26.2,52.9V34.39A1.373,1.373,0,0,1,27.59,33h3.042a1.373,1.373,0,0,1,1.39,1.39V52.9a1.373,1.373,0,0,1-1.39,1.39H27.59A1.373,1.373,0,0,1,26.2,52.9Zm4.693-.478v-17.6a.686.686,0,0,0-.7-.7H28.068a.686.686,0,0,0-.7.7V52.38a.686.686,0,0,0,.7.7H30.2A.649.649,0,0,0,30.893,52.424Z",
    transform: "translate(-26.2 -33)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.bbd79757705f65d746d434485f912118.svg";
export { ForwardRef as ReactComponent };